<template>
  <div>
		<notify @closeNotice='closeNotice' :shouldNoticeShow='shouldNoticeShow' :title='noticeTitle' :content='noticeContent'></notify>
		<div class='print-page'>
		<div id='address-container' @click="toAddress">
			<div id='no-address' v-if='!consigneeName'>
				<img src="../assets/address_add.png" id='add-address-icon' />添加地址信息
			</div>
			<div id='address' v-else>
				<div class='address1'>{{consigneeName}}　{{consigneePhone}}</div>
				<div class='address2'>{{city+detailAddr}}</div>
				<div class='address3'><img src='../assets/icon_arrow.png' mode="aspectFit" class='point'/></div>
			</div>
		</div>
			<div id='digital-info'>
				<div id='spec-container'>{{specInfo.specName}}</div>
				<img :src="chosenPrintPhotoSrc" id='print-photo' mode='widthFix' />
			</div>
			<div class='cell cell-up'>
				<div class='cell-title'>冲印版数</div>
				<div class='number-container'>
					<img class='number-control' src="../assets/minus.png" @click="minusQty"></img>
					<div id="number-show">{{printPhotoQty}}</div>
					<img class='number-control' id="number-control-right" src="../assets/add.png" @click="addQty"></img>版
				</div>
			</div>
			<div class='cell cell-down'>
				<div class='cell-title'>应付总价（包邮）</div>
				<div class='price price-in-cell'><span class='yuan'>￥</span><span class='price-num'>{{totalPrintPrice}}</span></div>
			</div>

			<div class='cell-interval-title'>配送方式</div>
			<div class='cell cell-up' style="position: relative;">
				<div class='cell-title'>加急快递</div>
				<img src="../assets/urgent.png" id='urgent-decoration' />
				<img :src='expressType=="urgent"?require("../assets/expressChosen.png"):require("../assets/expressChoose.png")' class='express-choose' @click="chooseExpress" :data-way='expressOptions[1].value' />
			</div>
			<div class='cell cell-down' >
				<div class='cell-title'>普通快递</div>
				<img :src='expressType=="normal"?require("../assets/expressChosen.png"):require("../assets/expressChoose.png")' class='express-choose' @click="chooseExpress" :data-way='expressOptions[0].value' />
			</div>
			</div>

			<div class='button-container'>
				<div class='price price-in-bottom'><span class='yuan'>￥</span><span class='price-num'>{{totalPrintPrice}}</span><span class='price-tip'>（应付款）</span></div>
				<div id='pay-button' @click="submitPrintOrder">立即支付</div>
			</div>
			
  </div>
</template>

<script>
import { submitPrintOrder,getPrintNotify } from "@/data/api";
import notify from "@/components/notify";
import PhotoContainer from "@/components/PhotoContainer";
import { mapState, mapMutations } from "vuex";
import { getStorage, setStorage, formatNumber } from "@/utils/utils";
import {alipay} from "@/utils/alipay";
export default {
  components: {
    PhotoContainer,
		notify
  },
  data() {
    return {
      chosenPrintPhotoSrc: null,
      consigneeName: "",
      consigneePhone: "",
      detailAddr: "",
      city: [],
			isAddress:false,
      expressType: "urgent",
      expressOptions: [
        {
          label: "普通快递",
          value: "normal"
        },
        {
          label: "加急快递",
          value: "urgent"
        }
      ],
			shouldNoticeShow:false,
			noticeTitle:'',
			noticeContent:''
    };
  },
  created() {
    ap.setNavigationBar({
      title: "提交冲印订单"
    });
		this.$ba.trackPageview('print');
    const { watermarkPrintPhotoSrc,origin_pic_name,final_pic_name,print_pic_name } = this.$route.query;
    this.chosenPrintPhotoSrc = watermarkPrintPhotoSrc;
    this.origin_pic_name = origin_pic_name;
    this.final_pic_name = final_pic_name;
    this.print_pic_name = print_pic_name;
    this.initAddr();
		getPrintNotify().then((res)=>{
			console.log(res)
			if(res.data.code==200){
				if(res.data.is_show==1){
					this.shouldNoticeShow=true;
					this.noticeTitle=res.data.notify_title;
					this.noticeContent=res.data.notify_msg;
				}
			}
		})
  },
  methods: {
    ...mapMutations(["RECORD_PRINT_QTY"]),
    checkDetailExpressIns() {
      ap.pushWindow({
        url: 'http://www.id-photo-verify.com/delivery_instructions/'
      });
    },
    addQty() {
      const currentQty = this.printPhotoQty;
      if (currentQty >= 20) {
        ap.showToast({
          content: "不能再多啦"
        });
      } else {
        this.RECORD_PRINT_QTY(currentQty + 1);
      }
    },
    minusQty() {
      const currentQty = this.printPhotoQty;
      if (currentQty <= 1) {
        ap.showToast({
          content: "亲，不能再少啦"
        });
      } else {
        this.RECORD_PRINT_QTY(currentQty - 1);
      }
    },
    initAddr() {
      const expressInfo = JSON.parse(getStorage("expressInfo"));
      if (expressInfo) {
        const { detailAddr, city, consigneeName, consigneePhone,cityCode} = expressInfo;
        this.detailAddr = detailAddr;
        this.consigneeName = consigneeName;
        this.consigneePhone = consigneePhone;
        this.city = city;
        this.cityCode=cityCode;
				this.isAddress=true;
      }
    },
    submitPrintOrder() {
      if (
        this.isAddress
      ) {
        ap.showLoading({
          content: "提交订单中"
        });
        submitPrintOrder(
        	this.specInfo.specName,
          this.consigneeName,
          this.consigneePhone,
   				this.detailAddr,
   				this.openId,
   				this.cityCode,
          this.printPhotoQty,
          this.origin_pic_name,
			    this.final_pic_name,
			    this.print_pic_name,
			    this.expressType
        ).then((res) => {
        	console.log(res)
          if (res.data.code === 200) {
            ap.hideLoading();
            // this.orderInfo.orderId=res.data.result.id;
//             this.$router.push({
//               name: "pay",
//               query: {
// 	            	pay_param:res.data.pay_param,
// 								tradeNo:res.data.trade_no,
//                 serialNum: res.data.result.order_no,
//                 orderType: this.expressType,
//                 totalPrice: this.totalPrintPrice
//               }
//             });
							this.pay(res.data.trade_no);
          }
        });
      } else{
        ap.showToast({
          content: "请编辑收货地址！"
        });
      }
    },
		pay(trade_no){
			alipay(trade_no)
				.then((res) => {
					if(res=='支付成功'){
						ap.hideLoading();
						this.$router.push({
							name: "orderList",
							query: {
								openId: this.openId,
								photoType:'print'
							}
						})
					}
				})
				.catch(err => {
					ap.hideLoading();
					if(err === "支付取消") {
						ap.showToast({
							content: err
						});
					} else {
						ap.confirm({
							title: '是否重新支付？',
							message: err
						}, (res) => {
							if(res.confirm) {
								this.pay(trade_no);
							}
						});
					}
				});
		},
		closeNotice(){
			this.shouldNoticeShow=false;
		},
		chooseExpress(e){
			this.expressType=e.target.dataset.way;
		},
		toAddress(){
			this.$router.push({ name: "address" });
		}
  },
  computed: {
    ...mapState([
      "processedPhoto",
      "bgColor",
      "specInfo",
      "orderInfo",
      "printPrice",
      "openId"
    ]),
    totalPrintPrice() {
      const originPrice = this.printPrice[this.expressType] * this.printPhotoQty;

      return formatNumber(originPrice, 2);
    },
    printPhotoQty: {
      get() {
        return this.$store.state.printPhotoQty;
      },
      set(val) {
        this.$store.commit("RECORD_PRINT_QTY", val);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.print-page{
  padding: 2.667vw 2.667vw 0 2.667vw;
}
#add-address-icon{
  display: inline-block;
  width: 12px;
  height: 12px;
}
#address-container{
  width: 94.667vw;
  min-height: 82px;
  height: auto;
  background:rgba(255,255,255,1);
  border-radius:6px; 
  
  background-image:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAWMAAAAFCAYAAACQGI0SAAABSElEQVRYR+3WoUtDURTH8e9BnyLuPxCDyehAhpjENIPYTDJsT8fCWHJic+ZVwWawikH/gZVhUxZsMsabhoVt6YkKV56oTLxncTI4r77DvYcP5/y44pxbAM6BVWAS+0zABEzABEYl8A7UgV1xzu0Dp6O62e4xARMwARP4I5BPwngKuAXSv37HMZTLUKvpbiJQKkEup9a8vMHJDdQfhxwD7K3B9rJSY734YczFXAYExPbIOw9j4HIHrCR94pybA65/ArnbhWIRGg09QYMAKhXIZtWafgxHV/DwPOSYCTjYgPVFpcZ68cOYi7kMCAS2R955GAOXJIg3RaT9GcZfgZy8kEM6nR3CcIlmc0aN0FQKqlXIZNSSpx4cXkLU04N4dhqOtyA9r9REERQK0Grph1gvfhtzMZdvAdsj/yz8n0sM3AMXwJmIvCYNfgD2bYWb16s3EQAAAABJRU5ErkJggg==');
  background-position:0 100%;
  background-repeat: repeat-x;
}
#no-address{
  font-size: 13px;
  color: #999999;
  padding: 32px 34.667vw;
}
#address{
 /* display: flex;  */
 padding: 15px;
 height: auto;
}
.address1{
  font-size: 18px;
  color:rgba(51,51,51,1);
  font-weight: bold;
  height: 25px;
  line-height: 25px;
}
.address2{
  height: auto;
  font-size: 13px;
  color:rgba(102,102,102,1);
  margin-top:10px;
  width: 80vw;
}
.address3{
  position: absolute;
  top:46px;
  right: 25px;
  width: 7px;
  height: 12px;
  color:rgba(191,191,191,1);
}
#digital-info{
  margin-top: 10px;
  width:94.667vw;
  background:rgba(255,255,255,1);
  border-radius:6px;
  padding: 11px 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
#print-photo{
  width: 34.6667vw;
}
#spec-container{
  width: 49.33vw;
  font-weight: bold;
  font-size: 17px;
  line-height: 24px;
  height: 48px;
  text-overflow: ellipsis;
  color:#333333;
  display: inline-block;
}

.number-container {
  text-align: center;
  font-size: 16px;
  margin-left: 75px;
  display: inline-flex;
  float: right;
  margin-top: 14px;
  line-height: 24px;
}

#number-show {
  display: inline-block;
  width: 33px;
  text-align: center;
}

.number-control {
  display: inline-block;
  height: 25px;
  width: 25px;
}
#number-control-right{
  margin-right: 9px;
}
.button-container{
  padding-left: 25px;
}
.cell-interval-title{
  padding-left: 15px;
  height: 32px;
  line-height: 42px;
  font-size: 13px;
  color: #999999;
}
.price-in-bottom{
  line-height: 60px;
}
.yuan{
  font-size: 14px;
}
.price-num{
  font-size:22px;
}
.price-tip{
  color: #999999;
  font-size: 13px;
  font-weight: 400;
}

#urgent-decoration{
  width: 40px;
  height: 18px;
  position: absolute;
  left:22.4vw;
  top: 15px;
}
.express-choose{
  width: 22px;
  height:22px;
  float: right;
  margin-top: 14px;
}
#pay-container{
  position: fixed;
  width:100vw;
  height:60px;
  background:rgba(255,255,255,1);
  box-shadow:0px 0px 16px 0px rgba(211,211,211,0.5);
  bottom: 0;
  padding-left: 25px;
}
#pay-button{
  display: inline-block;
  width: 39.2vw;
  height: 45px;
  background:rgba(68,128,231,1);
  border-radius:22.5px;
  color:white;
  line-height: 45px;
  font-weight: 500;
  text-align: center;
  font-size: 16px;
  position: absolute;
  right: 2.4vw;
  top: 8px;
}
</style>
